import type * as React from 'react'

// eslint-disable-next-line
export function mergeRefs<T = any>(
  refs: Array<React.MutableRefObject<T> | React.LegacyRef<T>>
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        try {
          ref(value)
        } catch (error) {
          // Ignore errors from invalid refs (e.g., selector strings passed as refs)
          // This can happen when @floating-ui tries to compute positions with malformed selectors
          if (
            error instanceof SyntaxError &&
            error.message.includes('is not a valid selector')
          ) {
            // Silently ignore selector errors from floating-ui
            return
          }
          throw error
        }
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value
      }
    })
  }
}
